import { useInfiniteQuery } from '@tanstack/react-query';
import { useSession } from '../../../../common/authorization/context/Session';
import { findImprIdpUsers } from '../../../../api/portalServices';

export const useIdpUsers = () => {
  const tenantId = useSession().tenantId;

  return useInfiniteQuery({
    queryKey: ['findIdpUsers'],
    queryFn: async ({ pageParam }) => {
      if (pageParam === undefined) {
        return { users: [], pageInfo: { count: 0, startIndex: 0 } };
      }
      const payload = {
        pageInfo: {
          count: 25,
          startIndex: pageParam,
        },
      };
      return findImprIdpUsers(payload, tenantId || '');
    },
    initialPageParam: 1, //startIndex
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      if (lastPage.pageInfo.count < 25) {
        return undefined;
      }
      return lastPage.pageInfo.startIndex + 25; // Increment startIndex for the next page
    },
    select: ({ pages }) => pages.flatMap((page) => page.users),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    retry: false,
  });
};
